import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { apiFeedbacksList, apiFeedbacksView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/feedbacks/getData', async datas => {
    const { data } = await apiFeedbacksList(datas)
    return data
})

export const getView = createAsyncThunk('admin/feedbacks/getView', async id => {
    if (!id) return viewData
    const { data } = await apiFeedbacksView(id)
    data.transformer_id = (data.transformers ?? []).map(e => e.transformer_id)
    data.transformer_test_id = (data.transformer_tests ?? []).map(e => e.transformer_test_id)
    data.inspector_id = (data.inspectors ?? []).map(e => e.inspector_id)
    data.customer_id = (data.customers ?? []).map(e => e.customer_id)
    data.remarks = data.remarks ?? []
    return data
})

const viewData = {
    project_id: '',
    transformer_id: [],
    transformer_test_id: [],
    inspector_id: [],
    customer_id: [],
    address: '',
    suggestions: '',
    remarks: [],
    signature: '',
    status: 0,
}

export const feedbacksSlice = createSlice({
    name: 'admin/feedbacks',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            start: moment().startOf('month').locale('en').format('YYYY-MM-DD'),
            end: moment().endOf('month').locale('en').format('YYYY-MM-DD'),
            inspector_id: '',
            customer_id: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
        setInspector: (state, { payload }) => {
            state.table.page = 1
            state.table.inspector_id = payload
        },
        setCustomer: (state, { payload }) => {
            state.table.page = 1
            state.table.customer_id = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate, setInspector, setCustomer } = feedbacksSlice.actions

export default feedbacksSlice.reducer
